var map = {
	"./number_of_students_csv/da.yml": 71789,
	"./number_of_students_csv/en.yml": 60489,
	"./photo_session_csv/da.yml": 18014,
	"./photo_session_csv/en.yml": 25746,
	"./user_elements/da.yml": 48111,
	"./user_elements/en.yml": 19719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43622;